export default __webpack_public_path__ + "static/media/en-safemars-whitepaper.aedfd10f.pdf";